import {
  type DistrictNcesId,
  districtNcesIdSchema,
} from "@nimble/datamodel/types/ncesId";

export const DISTRICT_JOB_DRAWER_PARAM = "districtJob";

const DISTRICT_JOB_DRAWER_VALUE_SEPARATOR = "/";

export function toDistrictJobDrawerValue(
  districtNcesId: DistrictNcesId,
  jobId: string,
) {
  return `${districtNcesId}${DISTRICT_JOB_DRAWER_VALUE_SEPARATOR}${jobId}`;
}

export function parseDistrictJobDrawerValue(value: string) {
  const [rawDistrictNcesId, jobId] = value.split(
    DISTRICT_JOB_DRAWER_VALUE_SEPARATOR,
  );
  const districtNcesId = districtNcesIdSchema.safeParse(rawDistrictNcesId);
  if (!districtNcesId.success || !jobId) return null;

  return { districtNcesId: districtNcesId.data, jobId };
}
